import React, {Component} from 'react';
import {action, observable} from 'mobx';
import {inject, observer} from 'mobx-react';
import './style.scss'

import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import {
  FormInput, Button, FormCheckbox, InputGroup, InputGroupText, InputGroupAddon
} from "shards-react";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


@inject(({ common }) => ({ updateDoc: common.updateDoc, getDoc: common.getDoc }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me }))

@observer
class MileageConfig extends Component {

  //basic
  @observable teamUser = {};
  @observable permissions = {}
  @observable company = {};
  @observable isLogin = false;

  //page
  @observable noticeText = "";
  @observable mileageSettings = {
    member: { text: 0, image:0, movie:0, instagram:0 },
    noMember: { text: 0, image:0, movie:0,instagram:0 },
    isNoMemberDiff: false,
    isAuto: false
  }

  @observable mileageBonusSettings = {
    isUse: true, // 마스터 토글 (전체 사용)
    isOnlyOnce: true,
    joinFirst: { isUse: false, mileage_1: 1000 },
    fsb:       { isUse: false, mileage_1: 1000, range_1: 10 },
    perImg:    { isUse: false, mileage_1: 1000, range_1: 5 },
    perText:   { isUse: false, mileage_1: 1000, range_1: 300 },
    early:     { isUse: false, mileage_1: 1000, range_1: 5 },
    fsbMovie:  { isUse: false, mileage_1: 1000, range_1: 10 },
    perMovie:  { isUse: false, mileage_1: 1000, range_1: 3 },
    snsJoinFirst: { isUse: false, mileage_1: 1000 },
    snsFsb:    { isUse: false, mileage_1: 1000, range_1: 10 }
  }

  // 변경 감지용 snapshot
  @observable initialSnapshot = '';
  @observable hasChanges = false;
  @observable saving = false;
  @observable hoveredHelp = null;

  constructor(props) {
    super(props)
    this.init();
  }

  @action
  init = async () => {
    let _this = this;
    if(!this.props.isLogin) return;
    this.isLogin = this.props.isLogin;
    this.teamUser = this.props.me;
    this.permissions = this.props.me.permissions;

    this.props.getDoc('getMileageConfig', {store_id: this.teamUser.selStore_id, shopNo:this.teamUser.selShopNo ? this.teamUser.selShopNo : 1}, function(res) {
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else if (res && res.data && res.data.store_id) {
        const r = res.data;
        _this.noticeText = r.noticeText || '';
        _this.mileageSettings = Object.assign({}, _this.mileageSettings, r.mileageSettings || {});
        _this.mileageBonusSettings = Object.assign({}, _this.mileageBonusSettings, r.mileageBonusSettings || {});
      }
      _this.mileageSettings.store_id = _this.teamUser.selStore_id;
      _this.mileageBonusSettings.store_id = _this.teamUser.selStore_id;
      _this._takeSnapshot();
    });
  };

  // === 변경 감지 ===
  _snapshot = () => JSON.stringify({m: this.mileageSettings, b: this.mileageBonusSettings});

  @action _takeSnapshot = () => {
    this.initialSnapshot = this._snapshot();
    this.hasChanges = false;
  };

  @action _checkDirty = () => {
    this.hasChanges = this._snapshot() !== this.initialSnapshot;
  };

  @action onChangeInputs = (event, targetObj) => {
    const { name, value } = event.target;
    targetObj[name] = value;
    this._checkDirty();
  };

  @action toggleField = (targetObj, key) => {
    if (key === 'isRate') {
      targetObj.member = { text: 0, image:0, movie:0, instagram:0 };
    }
    targetObj[key] = !targetObj[key];
    this._checkDirty();
  };

  @action setRateMode = (rate) => {
    if (this.mileageSettings.isRate !== rate) {
      this.mileageSettings.member = { text: 0, image:0, movie:0, instagram:0 };
    }
    this.mileageSettings.isRate = rate;
    this._checkDirty();
  };

  // === 저장/취소 ===
  saveAll = async () => {
    if (this.saving) return;
    this.saving = true;
    const _this = this;

    const baseParams = {
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1
    };

    const callUpdate = (data) => new Promise((resolve) => {
      _this.props.updateDoc('updateMileageConfig', data, (res) => resolve(res));
    });

    try {
      const r1 = await callUpdate(Object.assign({}, baseParams, {mileageSettings: this.mileageSettings}));
      if (r1 && r1.errors && r1.errors.length > 0) throw new Error(r1.errors[0].message);

      const r2 = await callUpdate(Object.assign({}, baseParams, {mileageBonusSettings: this.mileageBonusSettings}));
      if (r2 && r2.errors && r2.errors.length > 0) throw new Error(r2.errors[0].message);

      toast.success('설정이 저장되었습니다.');
      this._takeSnapshot();
    } catch (e) {
      toast.error('저장 실패: ' + (e.message || ''));
    } finally {
      this.saving = false;
    }
  };

  @action resetChanges = () => {
    if (!this.initialSnapshot) return;
    if (!window.confirm('변경 내용을 모두 취소하고 마지막 저장 시점으로 되돌립니다. 계속할까요?')) return;
    try {
      const snap = JSON.parse(this.initialSnapshot);
      this.mileageSettings = Object.assign({}, this.mileageSettings, snap.m || {});
      this.mileageBonusSettings = Object.assign({}, this.mileageBonusSettings, snap.b || {});
      this.hasChanges = false;
    } catch (e) {}
  };

  // === 도움말 tooltip ===
  showHelp = (key) => { this.hoveredHelp = key; };
  hideHelp = () => { this.hoveredHelp = null; };

  // === 추가 적립금 조건 카드 (재사용) ===
  renderConditionCard = (def) => {
    const ms = this.mileageBonusSettings;
    const target = ms[def.key];
    const isOn = !!target.isUse;
    const masterOff = !ms.isUse;
    return (
      <div className={`mc-cond-card ${isOn ? 'is-on' : ''}`} key={def.key}>
        <div className="mc-cond-card__head">
          <FormCheckbox toggle small
                        checked={isOn}
                        disabled={masterOff}
                        onChange={() => this.toggleField(target, 'isUse')}>
            <span className="mc-cond-card__title">{def.title}</span>
          </FormCheckbox>
          <span className="mc-help"
                onMouseEnter={() => this.showHelp(def.key)}
                onMouseLeave={this.hideHelp}>
            <FeatherIcon icon="help-circle" size="14"/>
            {this.hoveredHelp === def.key && (
              <span className="mc-tooltip">{def.help}</span>
            )}
          </span>
        </div>
        <div className="mc-cond-card__body" style={{display: isOn ? 'grid' : 'none'}}>
          {def.range && (
            <div className="mc-field">
              <label className="mc-field__label">조건</label>
              <div className="mc-field__row">
                {def.rangePrefix && <span className="mc-field__txt">{def.rangePrefix}</span>}
                <FormInput type="number"
                           name="range_1"
                           value={target.range_1 || 0}
                           disabled={masterOff || !isOn}
                           onChange={(e) => this.onChangeInputs(e, target)}
                           className="mc-input"/>
                <span className="mc-field__suffix">{def.rangeSuffix}</span>
              </div>
            </div>
          )}
          {!def.range && def.fixedConditionText && (
            <div className="mc-field">
              <label className="mc-field__label">조건</label>
              <div className="mc-field__row">
                <span className="mc-field__txt mc-field__txt--fixed">{def.fixedConditionText}</span>
              </div>
            </div>
          )}
          <div className="mc-field">
            <label className="mc-field__label">적립금</label>
            <div className="mc-field__row">
              <FormInput type="number"
                         name="mileage_1"
                         value={target.mileage_1 || 0}
                         disabled={masterOff || !isOn}
                         onChange={(e) => this.onChangeInputs(e, target)}
                         className="mc-input"/>
              <span className="mc-field__suffix">원</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const ms = this.mileageSettings;
    const ba = this.mileageBonusSettings;
    const masterOff = !ba.isUse;
    const suffix = ms.isRate ? '%' : '원';
    const isFixed = !ms.isRate;

    const conditionDefs = [
      {
        key: 'perText',
        title: '장문 텍스트',
        help: '텍스트 리뷰가 지정 글자수 이상일 때 추가 적립금을 지급합니다',
        range: true, rangeSuffix: '자 이상 작성 시'
      },
      {
        key: 'perImg',
        title: '많은 이미지',
        help: '이미지가 지정 장수 이상 포함된 리뷰에 추가 적립금을 지급합니다',
        range: true, rangeSuffix: '장 이상'
      },
      {
        key: 'fsb',
        title: '선착순',
        help: '제품별 리뷰 선착순으로 추가 적립금을 지급합니다',
        range: true, rangePrefix: '제품당 리뷰 선착순', rangeSuffix: '등 까지'
      },
      {
        key: 'joinFirst',
        title: '회원 최초',
        help: '회원가입 후 처음 작성하는 포토리뷰에 추가 적립금을 지급합니다',
        range: false, fixedConditionText: '회원가입 후 첫 번째로 작성한 포토리뷰'
      }
    ];

    return (
      <div className="main-content mc-page">
        <PageTitle />
        <div className="mc-wrap">

          {/* === 카드 1: 기본 적립금 지급 설정 === */}
          <section className="mc-card" id="basicMileageSettings">
            <header className="mc-card__head">
              <div className="mc-card__title-wrap">
                <span className="mc-card__icon"><FeatherIcon icon="credit-card" size="18"/></span>
                <div>
                  <h3 className="mc-card__title">기본 적립금 지급 설정</h3>
                  <p className="mc-card__desc">리뷰 유형별 기본 적립금 지급 금액을 설정합니다.</p>
                </div>
              </div>
            </header>

            {/* 적립 방식 라디오 카드 */}
            <div className="mc-radio-cards">
              <div className={`mc-radio-card ${isFixed ? 'is-active' : ''}`}
                   onClick={() => this.setRateMode(false)}>
                <div className="mc-radio-card__head">
                  <span className={`mc-radio-dot ${isFixed ? 'is-on' : ''}`}/>
                  <span className="mc-radio-card__title">고정 금액 적립</span>
                </div>
                <p className="mc-radio-card__desc">리뷰 작성 시 고정 적립금 지급</p>
              </div>
              <div className={`mc-radio-card ${!isFixed ? 'is-active' : ''}`}
                   onClick={() => this.setRateMode(true)}>
                <div className="mc-radio-card__head">
                  <span className={`mc-radio-dot ${!isFixed ? 'is-on' : ''}`}/>
                  <span className="mc-radio-card__title">결제 금액 비례(%) 적립</span>
                </div>
                <p className="mc-radio-card__desc">상품 결제 금액의 백분율로 지급 (10단위 반올림)</p>
              </div>
            </div>

            {/* 자동 적립 토글 */}
            <div className="mc-toggle-row">
              <FormCheckbox toggle small
                            checked={!!ms.isAuto}
                            onChange={() => this.toggleField(ms, 'isAuto')}>
                <span className="mc-toggle-row__label">자동 적립</span>
              </FormCheckbox>
              <span className="mc-toggle-row__desc">리뷰 작성 즉시 자동으로 적립합니다</span>
            </div>

            {/* 리뷰 유형별 적립금 — 자동 적립 여부와 무관하게 항상 설정 가능 */}
            <div className="mc-amount-grid-wrap">
              <div className="mc-amount-grid">
                {[
                  {key: 'text',  icon: 'edit-3',  label: '텍스트'},
                  {key: 'image', icon: 'image',   label: '포토'},
                  {key: 'movie', icon: 'video',   label: '동영상'}
                ].map(item => (
                  <div className="mc-amount-card" key={item.key}>
                    <div className="mc-amount-card__head">
                      <FeatherIcon icon={item.icon} size="16"/>
                      <span>{item.label}</span>
                    </div>
                    <InputGroup className="mc-amount-input">
                      <FormInput type="number"
                                 name={item.key}
                                 value={ms.member[item.key]}
                                 onChange={(e) => this.onChangeInputs(e, ms.member)}
                                 className="text-center"/>
                      <InputGroupAddon type="append">
                        <InputGroupText>{suffix}</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* === 카드 2: 추가 적립금 === */}
          <section className="mc-card" id="bonusMileageSettings">
            <header className="mc-card__head mc-card__head--with-toggle">
              <div className="mc-card__title-wrap">
                <span className="mc-card__icon"><FeatherIcon icon="gift" size="18"/></span>
                <div>
                  <h3 className="mc-card__title">추가 적립금</h3>
                  <p className="mc-card__desc">특정 조건을 충족한 리뷰에 추가 적립금을 지급합니다.</p>
                </div>
              </div>
              <div className="mc-card__head-toggle">
                <FormCheckbox toggle small
                              checked={!!ba.isUse}
                              onChange={() => this.toggleField(ba, 'isUse')}>
                  사용
                </FormCheckbox>
              </div>
            </header>

            {/* 자동 적립 (하위 토글) */}
            <div className={`mc-toggle-row ${masterOff ? 'is-disabled' : ''}`}>
              <FormCheckbox toggle small
                            checked={!!ba.isBonusAuto}
                            disabled={masterOff}
                            onChange={() => this.toggleField(ba, 'isBonusAuto')}>
                <span className="mc-toggle-row__label">자동 적립</span>
              </FormCheckbox>
              <span className="mc-toggle-row__desc">조건 충족 시 자동으로 적립합니다</span>
            </div>

            <div className={`mc-bonus-body ${masterOff ? 'is-disabled' : ''}`}>
              {/* 한 번만 지급 — 분리된 주의색 카드 */}
              <div className="mc-cond-card mc-cond-card--warn is-on">
                <div className="mc-cond-card__head">
                  <FormCheckbox toggle small
                                checked={!!ba.isOnlyOnce}
                                disabled={masterOff}
                                onChange={() => this.toggleField(ba, 'isOnlyOnce')}>
                    <span className="mc-cond-card__title">추가 적립금은 한 번만 지급</span>
                  </FormCheckbox>
                  <span className="mc-help"
                        onMouseEnter={() => this.showHelp('isOnlyOnce')}
                        onMouseLeave={this.hideHelp}>
                    <FeatherIcon icon="help-circle" size="14"/>
                    {this.hoveredHelp === 'isOnlyOnce' && (
                      <span className="mc-tooltip">리뷰에서 추가적립금 종류 중 최대 적립금 1번만 지급되도록 제한합니다</span>
                    )}
                  </span>
                </div>
                <div className="mc-cond-card__note">
                  활성화 시: 한 리뷰가 여러 조건을 충족해도 가장 큰 추가 적립금만 1회 지급
                </div>
              </div>

              <div className="mc-cond-divider"/>

              {/* 4개 조건 카드 */}
              {conditionDefs.map(this.renderConditionCard)}
            </div>
          </section>

        </div>

        {/* === 통합 Sticky 저장 바 — 다른 Review 페이지(reviewWriteConfig)와 동일 패턴 === */}
        {this.hasChanges && (
          <div className="wbp-sticky-save wbp-sticky-save--top">
            <div className="wbp-sticky-save__msg">
              <FeatherIcon icon="alert-circle" size="16"/>
              <span>저장되지 않은 변경사항이 있습니다.</span>
              <span className="wbp-sticky-save__tags">
                <span className="wbp-sticky-save__tag">마일리지 설정</span>
              </span>
            </div>
            <div className="wbp-sticky-save__actions">
              <Button theme="light" size="sm" onClick={this.resetChanges} disabled={this.saving}>되돌리기</Button>
              <Button theme="primary" size="sm" onClick={this.saveAll} disabled={this.saving}>
                <FeatherIcon icon={this.saving ? 'loader' : 'save'} size="13"/>
                {this.saving ? ' 저장 중…' : ' 변경사항 저장'}
              </Button>
            </div>
          </div>
        )}

      </div>
    )
  }
}

export default MileageConfig;
